import App from './controllers/App';

const app = new App();

app.start();

// console.log('jewnj');
